// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3D0w3","disabled":"FileBtn_disabled__1fI_G","warn":"FileBtn_warn__4TF0J","fade":"FileBtn_fade__8NG1X"};